export default "__VITE_ASSET__BrJ1jORk__"